(function () {
    'use strict';

    angular.module('SMART2').service('ScrollTo', [function () {
        var scrollingTopMargin = 0;
        this.setScrollingTopMargin = function (_scrollingTopMargin) {
            scrollingTopMargin = _scrollingTopMargin;
        }
        this.perform = function (source, destination, onComplete) {
            try {
                angular.element(source.closest('.modal').length > 0 ? source.closest('.modal') : 'body,html').animate({
                    scrollTop: (source.offset().top - destination.offset().top) + scrollingTopMargin,

                }, 400, function () {
                    if (typeof onComplete != "undefined") {
                        onComplete();
                    }
                });
            } catch (e) { }
        };
    }]);
})();